import { Action, createReducer, on } from '@ngrx/store';
import { ILegalEntityTypesResponse } from '../models/legal-entity-types.model';
import * as actions from '../actions';

export const legalEntityTypeFeatureKey = 'legalEntityType';

export interface LegalEntityTypeState {
  loadLegalEntityTypeResponse: ILegalEntityTypesResponse[];
  loadLegalEntityTypeFailure: Error | any;
}

export const initialState: LegalEntityTypeState = {
  loadLegalEntityTypeResponse: undefined,
  loadLegalEntityTypeFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadLegalEntityTypesSuccess, (state, action) => ({
    ...state,
    loadLegalEntityTypeResponse: action.response
  }))
);

export const getLegalEntityTypes = (state: LegalEntityTypeState) => state.loadLegalEntityTypeResponse;
